import { subscribeToSchemeChange } from '@epic-web/client-hints/color-scheme';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { getAppShellDataQueryOptions } from '~/server/app/app-shell-data-query.ts';

import { getClientHintCheckScript } from './client-hints.tsx';

export function useHints() {
	const { data } = useSuspenseQuery(getAppShellDataQueryOptions());

	return data.requestInfo.hints;
}

export function useIsMobile() {
	const { width } = useHints();
	const [isMobile, setIsMobile] = useState(width < 600);

	useEffect(() => {
		function handleResize() {
			setIsMobile(window.innerWidth < 600);
		}

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return isMobile;
}

export function StartClientHintCheck() {
	const router = useRouter();

	useEffect(() => subscribeToSchemeChange(() => void router.invalidate()), [router]);

	return (
		<script
			// biome-ignore lint/security/noDangerouslySetInnerHtml: client hint bootstrap
			dangerouslySetInnerHTML={{
				__html: getClientHintCheckScript(),
			}}
		/>
	);
}
